<template>
  <el-dialog
    title="订单详情"
    width="50%"
    :visible.sync="isShow"
    @close="closeDialog"
  >
    <el-table
      v-loading="loading"
      :data="orderDetailData"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
      border
      style="width: 100%; margin: 0 auto"
    >
      <el-table-column
        prop="orderId"
        label="订单编号"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="orderStartTime"
        label="下单时间"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="paymentConfirmTime"
        label="付款时间"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="orderPayment"
        label="订单金额"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="orderStateRemark"
        label="订单状态"
        min-width="120"
      ></el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right; margin: 20px"
      @size-change="handleSizeChange"
      background
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageInfo.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="Number(pageInfo.total)"
      :current-page="pageInfo.current"
    ></el-pagination>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialog">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getOrderRrankorderDetail } from "@/api/paradiseAndTaskCommonController.js";
export default {
  props: {
    currentId: {
      // 活动数据
      type: Number | String,
      default: -1,
    },
  },
  data() {
    return {
      isShow: true,
      loading: false, // 加载
      orderDetailData: [], // 订单明细
      pageInfo: {
        // 订单明细分页
        current: 1, // 当前页
        size: 10, // 每页条数
        total: 0, // 总条数
      },
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    getDetail() {
      this.loading = true;
      getOrderRrankorderDetail({
        id: this.currentId,
        current: this.pageInfo.current,
        size: this.pageInfo.size,
      })
        .then((res) => {
          this.loading = false;
          if (res && res.code == 1) {
            this.orderDetailData = res.data.records;
            this.pageInfo.total = res.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.pageInfo.size = val;
      this.getDetail();
    },
    handleCurrentChange(val){
      this.pageInfo.current = val;
      this.getDetail();
    }
  },
  created() {
    this.getDetail();
  },
};
</script>
